module.exports = new __parcel__URL__("btn_instagram.b3763a73.png").toString();